module.exports = __webpack_public_path__ + "img/govtech-white.9c72752c.png";